import React, { useEffect, useRef, useState } from "react";

import { Input, Spin } from "../../../BP2Components";
import { isFieldDisabled, getValueFormat, toDisplayString } from "./FormFIeldsV3Decorators";
import { useDebouncedCallback } from "use-debounce";

import "../formsV3.less";
import { useFieldController } from "../../../../util/useFieldController";

const applyNumericFormat = (value, format) => {
   if (!format || value === "" || value === null || value === undefined) return value;
   const trimmed = String(value).trim();
   if (trimmed === "") return value;
   const num = Number(trimmed);
   if (!Number.isFinite(num)) return value;
   if (format === "#") return String(Math.round(num));
   const match = format.match(/^#\.(0+)$/);
   if (match) return num.toFixed(match[1].length);
   return value;
};

const FormV3InputField = ({ field, formGUID, type, loading, decorators, onValueChange }) => {
   const numericFormat = getValueFormat(field);
   const isNumeric = type === "Number" || type === "Decimal";
   const [localValue, setLocalValue] = useState(() => {
      const raw = toDisplayString(field?.value);
      return isNumeric && numericFormat ? applyNumericFormat(raw, numericFormat) : raw;
   });
   const isTypingRef = useRef(false);
   const {
      value: ctxValue,
      setValue: setCtxValue,
      fieldInfo,
   } = useFieldController({
      field,
      formGUID,
      onValueChange,
   });

   const commitDebounced = useDebouncedCallback((val) => {
      isTypingRef.current = false;
      setCtxValue(val);
   }, 500);

   const handleValueChange = (e) => {
      const next = e.target.value;
      isTypingRef.current = true;
      setLocalValue(next);
      commitDebounced(next);
   };

   const handleBlur = () => {
      // Commit the raw typed value to context (preserves full numeric precision for the backend).
      // The useEffect watching ctxValue then applies numericFormat for display only.
      commitDebounced.flush();
   };

   useEffect(() => {
      if (isTypingRef.current) return;
      const raw = toDisplayString(ctxValue);
      setLocalValue(isNumeric && numericFormat ? applyNumericFormat(raw, numericFormat) : raw);
   }, [ctxValue, isNumeric, numericFormat]);
   return (
      <>
         <span className={`v3-field-element`}>
            <Input
               disabled={isFieldDisabled(field)}
               customClassName={`v3-field id-${field.id}`}
               value={localValue}
               placeholder={field.placeholder}
               onChange={handleValueChange}
               onBlur={handleBlur}
               type={isNumeric && !numericFormat ? "number" : "text"}
               inputMode={isNumeric && numericFormat ? "decimal" : undefined}
               style={fieldInfo ? { borderColor: `var(--form-warnings)` } : {}}
            ></Input>
            <span className="p2 dev-info">{field.id}</span>
            {fieldInfo ? <div className="validation-error">{fieldInfo}</div> : null}
         </span>
         {loading && <Spin></Spin>}
      </>
   );
};

export default FormV3InputField;
